// @ts-nocheck

import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import Client from '../../../../client';
import config from '../../../../config/app.config';
import { StorageKeys } from '../../../../constants/storage';
import useCopyToClipboard from '../../../../hooks/useCopyClipboard';
import useMergeProps from '../../../../hooks/useMergeProps';
import { __, getLang } from '../../../../i18n/l10n';
import { callNative, requestTypes } from '../../../../lib/bridge';
import { isAndroid } from '../../../../lib/useragent';
import UrlShort from '../../../../managers/urlShort';
import { selectUserJwtToken, selectUserNickname } from '../../../../selectors/user/userPrimary.selector';
import { webShare } from '../../../../utils';
import { useBetslipOptionsContext } from '../../context/BetslipOptionsContext';

import BetslipOptionsShareLinkItem from './BetslipOptionsShareLinkItem';

type BetslipOptionsShareLinkItemContainerProps = {
  showNewTag?: boolean;
};

const BetslipOptionsShareLinkItemContainer = (ownProps: BetslipOptionsShareLinkItemContainerProps) => {
  const [isSuccessCopy, setIsSuccessCopy] = useState<boolean | null>(null);
  const { onCopy } = useCopyToClipboard();
  const { betslipRef } = useBetslipOptionsContext();

  const jwt = useSelector(selectUserJwtToken);
  const nickname = useSelector(selectUserNickname);

  const shareUrl = useCallback(async () => {
    if (!betslipRef || !jwt) {
      return null;
    }

    const showPseudo = localStorage.getItem(StorageKeys.USER_PREFS_SHARE_NICKNAME) || true;
    const showWinningsAndStake = localStorage.getItem(StorageKeys.USER_PREFS_SHARE_STACK) || true;

    const options = {
      betslipReference: betslipRef,
      showPseudo,
      nickname: showPseudo ? nickname : null,
      stack: showWinningsAndStake,
    };

    try {
      const lang = getLang();
      const host = config.shareBetslipShareUrl[lang];

      const params = {
        jwt,
        wam: `wam://betting?target=betshare&ref=${betslipRef}`,
        data: options,
        fragment: `betshare/${betslipRef}`,
        ...host,
      };

      const shortId = await UrlShort.createShortDatas(params);

      return `${config.linkHost}/${shortId}`;
    } catch (error) {
      console.error(error);
      return null;
    }
  }, [betslipRef, jwt, nickname]);

  const resetSuccessCopy = useCallback(() => {
    setIsSuccessCopy(null);
  }, []);

  const onShareClick = useCallback(async () => {
    const url = await shareUrl();

    const shareData = {
      title: __("Share bet to a friend's basket"),
      url,
    };

    if (navigator.share) {
      webShare.share(shareData);
    } else if (Client.embed && isAndroid) {
      (async () => {
        await callNative(requestTypes.SHARE_TEXT, JSON.stringify(shareData));
      })();
    } else {
      try {
        if (!url) {
          setIsSuccessCopy(false);
          return;
        }
        onCopy(url);
        setIsSuccessCopy(true);
      } catch (error) {
        console.error(error);
      }
    }
  }, [onCopy, shareUrl]);

  const otherProps = useMemo(
    () => ({
      isSuccessCopy,
      resetSuccessCopy,
      onShareClick,
    }),
    [isSuccessCopy, onShareClick, resetSuccessCopy],
  );

  const enhancedProps = useMergeProps({ otherProps, ownProps });

  return <BetslipOptionsShareLinkItem {...enhancedProps} showNewTag />;
};

export default BetslipOptionsShareLinkItemContainer;
